import { useState, useEffect } from "react";
import { Form, Button, Col, Row } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import * as XLSX from "xlsx";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faUpload,
  faDownload,
  faXmark,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { APIUS } from "../../../../../../config/apius";
import { APIMS } from "../../../../../../config/apims";
import LoaderAction from "../../../../../Loader/LoaderHome";
import "bulma/css/bulma.css";
import "../../../../../../index.css";

// 90 kolom header sesuai tabel ysb_students (tanpa kolom filter, relasi khusus, status, dan sistem)
export const STUDENT_COLUMNS = [
  "nama_lengkap",
  "nisn",
  "nis_ypi",
  // "kode_absen",
  "order_absen",
  // "tahun_ajaran",
  // "tahun_ajaran_pindahan",
  // "file_akte_kelahiran",
  // "file_kartu_keluarga",
  // "file_ktp_orang_tua",
  // "file_raport",
  // "file_surat_keterangan_asal_sekolah",
  "nama_alias",
  "jenis_kelamin",
  "no_portal",
  "nik",
  "no_kk",
  "tempat_lahir",
  "tanggal_lahir_siswa",
  "agama",
  "kewarnegaraan",
  "anak_ke",
  "jumlah_saudara_kandung",
  "bahasa_dirumah",
  "email_murid",
  "email_siswa",
  "alamat_lengkap",
  "provinsi",
  "kota_kabupaten",
  "kecamatan",
  "kelurahan",
  "kode_pos",
  "warga_summarecon",
  "jarak_rumah_sekolah",
  "waktu_tempuh_sekolah",
  "ke_sekolah_dengan",
  "penyakit_diderita",
  "kelainan_jasmani",
  "pernah_dirawat_di",
  "tinggi",
  "berat",
  "linkar_kepala",
  "ukuran_sepatu",
  "sekolah_asal",
  "provinsi_asal",
  "kota_kabupaten_asal",
  "kecamatan_asal",
  "kelurahan_desa_asal",
  "kode_pos_asal",
  "nama_sekolah_asal",
  "akreditasi_sekolah_asal",
  "pindahan_dari_sekolah",
  // "syarat_1",
  // "syarat_2",
  // "syarat_3",
  // "syarat_4",
  "nama_lengkap_ayah",
  "nik_ayah",
  "tempat_lahir_ayah",
  "tanggal_lahir_ayah",
  "kewarganegaraan_ayah",
  "pendidikan_terakhir_ayah",
  "pekerjaan_ayah",
  "penghasilan_ayah",
  "no_handphone_ayah",
  "alamat_email_ayah",
  "keterangan_ayah",
  "nama_lengkap_ibu",
  "nik_ibu",
  "tempat_lahir_ibu",
  "tanggal_lahir_ibu",
  "kewarnegaraan_ibu",
  "pekerjaan_ibu",
  "penghasilan_ibu",
  "no_handphone_ibu",
  "alamat_email_ibu",
  "keterangan_ibu",
  "bidang_akademik",
  "kesenian",
  "pendidikan_jasmani",
  // "lain_lain",
  "saudara_kandung_di_sekolah",
  // "internet",
  // "billboard",
  // "teman",
  // "pameran",
  // "rekomendasi_asal_sekolah",
  // "spanduk",
  // "keluarga",
];

export const downloadStudentTemplate = () => {
  const sampleRow = {
    nama_lengkap: "Ahmad Fulan",
    nisn: "0012345678",
    nis_ypi: "4408-2425001",
    // kode_absen: "",
    order_absen: "",
    // tahun_ajaran: "",
    // tahun_ajaran_pindahan: "",
    // file_akte_kelahiran: "",
    // file_kartu_keluarga: "",
    // file_ktp_orang_tua: "",
    // file_raport: "",
    // file_surat_keterangan_asal_sekolah: "",
    nama_alias: "Ahmad",
    jenis_kelamin: "Laki-laki",
    no_portal: "",
    nik: "3275000000000001",
    no_kk: "3275000000000002",
    tempat_lahir: "Bekasi",
    tanggal_lahir_siswa: "2015-05-12",
    agama: "Islam",
    kewarnegaraan: "WNI",
    anak_ke: "1",
    jumlah_saudara_kandung: "2",
    bahasa_dirumah: "Indonesia",
    email_murid: "ahmad@example.com",
    email_siswa: "ahmad.siswa@example.com",
    alamat_lengkap: "Jl. Boulevard No. 1",
    provinsi: "Jawa Barat",
    kota_kabupaten: "Kota Bekasi",
    kecamatan: "Medan Satria",
    kelurahan: "Pejuang",
    kode_pos: "17131",
    warga_summarecon: "1",
    jarak_rumah_sekolah: "2 km",
    waktu_tempuh_sekolah: "15 menit",
    ke_sekolah_dengan: "Kendaraan Pribadi",
    penyakit_diderita: "-",
    kelainan_jasmani: "-",
    pernah_dirawat_di: "-",
    tinggi: "135",
    berat: "32",
    linkar_kepala: "52",
    ukuran_sepatu: "35",
    sekolah_asal: "TK Islam Al Azhar",
    provinsi_asal: "Jawa Barat",
    kota_kabupaten_asal: "Kota Bekasi",
    kecamatan_asal: "Medan Satria",
    kelurahan_desa_asal: "Pejuang",
    kode_pos_asal: "17131",
    nama_sekolah_asal: "TK Islam Al Azhar",
    akreditasi_sekolah_asal: "A",
    pindahan_dari_sekolah: "",
    // syarat_1: "0",
    // syarat_2: "0",
    // syarat_3: "0",
    // syarat_4: "0",
    nama_lengkap_ayah: "Fulan Senior",
    nik_ayah: "3275000000000003",
    tempat_lahir_ayah: "Jakarta",
    tanggal_lahir_ayah: "1980-01-01",
    kewarganegaraan_ayah: "WNI",
    pendidikan_terakhir_ayah: "S1",
    pekerjaan_ayah: "Karyawan Swasta",
    penghasilan_ayah: "> 10.000.000",
    no_handphone_ayah: "081234567890",
    alamat_email_ayah: "ayah@example.com",
    keterangan_ayah: "Ayah Kandung",
    nama_lengkap_ibu: "Fulanah",
    nik_ibu: "3275000000000004",
    tempat_lahir_ibu: "Bandung",
    tanggal_lahir_ibu: "1983-05-10",
    kewarnegaraan_ibu: "WNI",
    pekerjaan_ibu: "Ibu Rumah Tangga",
    penghasilan_ibu: "-",
    no_handphone_ibu: "081234567891",
    alamat_email_ibu: "ibu@example.com",
    keterangan_ibu: "Ibu Kandung",
    bidang_akademik: "Matematika",
    kesenian: "Menggambar",
    pendidikan_jasmani: "Berenang",
    // lain_lain: "-",
    saudara_kandung_di_sekolah: "-",
    // internet: "1",
    // billboard: "1",
    // teman: "1",
    // pameran: "1",
    // rekomendasi_asal_sekolah: "1",
    // spanduk: "1",
    // keluarga: "1",
  };

  const ws = XLSX.utils.json_to_sheet([sampleRow], { header: STUDENT_COLUMNS });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template Siswa");
  XLSX.writeFile(wb, "template_import_siswa.xlsx");
};

export default function ModalImport(props) {
  const token = localStorage.getItem("token");
  const level = localStorage.getItem("level") || "developer";
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");

  // Options for filters
  const [branches, setBranches] = useState([]);
  const [schools, setSchools] = useState([]);
  const [grades, setGrades] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [semesters, setSemesters] = useState([]);

  const [form, setForm] = useState({
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_academic_year_id: "",
    ysb_semester_id: "",
  });

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    const loadInitialFilters = async () => {
      try {
        const [resBranches, resAcademicYears, resSemesters] = await Promise.all([
          APIMS.get("/api/branches?page=0&limit=100&ascending=0&search=", fetchParams).catch(() => null),
          APIMS.get("/api/academic-years?page=1&limit=1000&ascending=1&search=", fetchParams).catch(() => null),
          APIMS.get("/api/semesters?page=1&limit=1000&ascending=1&search=", fetchParams).catch(() => null),
        ]);

        const semesterList = resSemesters?.data?.data;
        if (Array.isArray(semesterList)) setSemesters(semesterList);

        if (resBranches?.data?.data) {
          setBranches(resBranches.data.data);
        }
        if (resAcademicYears?.data?.data) {
          const academicYearList = resAcademicYears.data.data;
          const sortedAcademicYears = [...academicYearList].sort((a, b) => {
            const activeA = Number(a?.status) === 1 ? 1 : 0;
            const activeB = Number(b?.status) === 1 ? 1 : 0;
            return activeB - activeA;
          });

          setAcademicYears(sortedAcademicYears);

          const active = sortedAcademicYears.find((year) => Number(year?.status) === 1);
          if (active) {
            const activeSemester = (Array.isArray(semesterList) ? semesterList : []).find(
              (semester) => String(semester.ysb_academic_year_id ?? semester.academic_year_id) === String(active.id) && Number(semester.status) === 1
            );
            setForm((prev) => ({
              ...prev,
              ysb_academic_year_id: active.id,
              ysb_semester_id: activeSemester?.id || "",
            }));
          }
        }
      } catch (e) {
        console.error("Gagal memuat opsi filter:", e);
      }
    };

    loadInitialFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBranchChange = async (branchId) => {
    setForm((prev) => ({
      ...prev,
      ysb_branch_id: branchId,
      ysb_school_id: "",
      ysb_grade_level_id: "",
    }));
    setSchools([]);
    setGrades([]);

    if (!branchId) return;

    try {
      const res = await APIMS.get(
        `/api/schools?page=0&limit=100&ascending=0&search=&ascending_name=true&branch=${branchId}`,
        fetchParams
      );
      if (res?.data?.data) {
        setSchools(res.data.data);
      }
    } catch (e) {
      setSchools([]);
    }
  };

  const handleSchoolChange = async (schoolId) => {
    setForm((prev) => ({
      ...prev,
      ysb_school_id: schoolId,
      ysb_grade_level_id: "",
    }));
    setGrades([]);

    if (!schoolId) return;

    try {
      const res = await APIMS.get(
        `/api/grade-levels?page=1&limit=1000&ascending=1&branch=${form.ysb_branch_id}&level=${level}`,
        fetchParams
      );
      if (res?.data?.data) {
        const filteredGrades = res.data.data.filter(
          (grade) => String(grade.ysb_school_id) === String(schoolId)
        );
        setGrades(filteredGrades);
      }
    } catch (e) {
      setGrades([]);
    }
  };

  const handleAcademicYearChange = (value) => {
    const [academicYearId, semesterId] = value ? value.split(":") : ["", ""];
    setForm((prev) => ({
      ...prev,
      ysb_academic_year_id: academicYearId,
      ysb_semester_id: semesterId,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const binaryStr = evt.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        if (!jsonData || jsonData.length === 0) {
          swal({
            title: "Peringatan",
            text: "File Excel kosong atau tidak memiliki baris data!",
            icon: "warning",
            timer: 3000,
            buttons: false,
          });
          setExcelData([]);
          return;
        }

        setExcelData(jsonData);
      } catch (err) {
        swal({
          title: "Error",
          text: "Gagal membaca berkas Excel. Pastikan format file benar (.xlsx atau .xls).",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
        setExcelData([]);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!excelData || excelData.length === 0) {
      swal({
        title: "Peringatan",
        text: "Silakan pilih berkas Excel yang valid terlebih dahulu!",
        icon: "warning",
        timer: 3000,
        buttons: false,
      });
      return;
    }

    setLoading(true);
    try {
      const normalizedStudents = excelData.map((s) => {
        const item = { ...s };
        if (item.warga_summarecon !== undefined && item.warga_summarecon !== null && item.warga_summarecon !== "") {
          const wsStr = String(item.warga_summarecon).trim().toLowerCase();
          if (["ya", "yes", "true", "1"].includes(wsStr)) {
            item.warga_summarecon = 1;
          } else if (["tidak", "no", "false", "0"].includes(wsStr)) {
            item.warga_summarecon = 0;
          }
        }
        return item;
      });

      const payload = {
        students: normalizedStudents,
        ysb_branch_id: form.ysb_branch_id || null,
        ysb_school_id: form.ysb_school_id || null,
        ysb_grade_level_id: form.ysb_grade_level_id || null,
        ysb_academic_year_id: form.ysb_academic_year_id || null,
        ysb_semester_id: form.ysb_semester_id || null,
      };

      const response = await APIUS.post("/api/students/upload", payload, fetchParams);

      if (response?.status === 200) {
        swal({
          title: "Berhasil",
          text: `Berhasil mengimpor ${response.data.total || excelData.length} data siswa!`,
          icon: "success",
          timer: 3000,
          buttons: false,
        });

        if (props.GetResponseData) {
          props.GetResponseData();
        }
        props.onHide();
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Terjadi kesalahan saat mengunggah data siswa.",
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog sims-modal-dialog-import"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-import-siswa"
    >
      {loading && <LoaderAction />}

      <Form onSubmit={handleSubmit}>
        <Modal.Header className="sims-modal-header">
          <div>
            <h5 id="modal-import-siswa" className="sims-modal-title">
              Import Data Siswa
            </h5>
            {/* <p className="sims-modal-subtitle">
              Unggah data siswa secara massal menggunakan berkas Excel
            </p> */}
          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={loading}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body className="sims-modal-body sims-import-body mt-2">
          {/* <div className="sims-import-section-title">
            Filter Penugasan <span>(Opsional)</span>
          </div> */}

          <div className="sims-import-filter-grid">
            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="import-academic-year">
                Semester
              </label>
              <select
                id="import-academic-year"
                className="sims-form-select"
                value={form.ysb_academic_year_id && form.ysb_semester_id ? `${form.ysb_academic_year_id}:${form.ysb_semester_id}` : ""}
                onChange={(e) => handleAcademicYearChange(e.target.value)}
                disabled={loading}
              >
                <option value="">Pilih Semester</option>
                {academicYears.flatMap((academicYear) =>
                  semesters
                    .filter((semester) => String(semester.ysb_academic_year_id ?? semester.academic_year_id) === String(academicYear.id))
                    .map((semester) => (
                      <option key={`${academicYear.id}:${semester.id}`} value={`${academicYear.id}:${semester.id}`}>
                        {academicYear.name || academicYear.name_year || academicYear.tahun_ajaran || academicYear.year}
                        {` (Semester ${semester.name || semester.semester || semester.semester_name || semester.number})`}
                        {Number(semester.status) === 1 ? " • Aktif" : ""}
                      </option>
                    ))
                )}
              </select>
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="import-branch">
                Cabang
              </label>
              <select
                id="import-branch"
                className="sims-form-select"
                value={form.ysb_branch_id}
                onChange={(e) => handleBranchChange(e.target.value)}
                disabled={loading}
              >
                <option value="">Pilih Cabang</option>
                {branches.map((b) => (
                  <option key={b.branch_code || b.id} value={b.branch_code || b.id}>
                    {b.name || b.nama_cabang || b.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="import-school">
                Sekolah
              </label>
              <select
                id="import-school"
                className="sims-form-select"
                value={form.ysb_school_id}
                onChange={(e) => handleSchoolChange(e.target.value)}
                disabled={!form.ysb_branch_id || loading}
              >
                <option value="">
                  {!form.ysb_branch_id ? "Pilih Cabang terlebih dahulu" : "Pilih Sekolah"}
                </option>
                {schools
                  .filter((s) => {
                    const code = String(s.school_code || s.code || "").toLowerCase();
                    const name = String(s.name || s.nama_sekolah || s.school_name || "").toLowerCase();
                    return !code.includes("basement") && !name.includes("basement");
                  })
                  .map((s) => (
                    <option key={s.school_code} value={ s.school_code}>
                      {s.school_name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="import-grade">
                Tingkatan
              </label>
              <select
                id="import-grade"
                className="sims-form-select"
                value={form.ysb_grade_level_id}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, ysb_grade_level_id: e.target.value }))
                }
                disabled={!form.ysb_school_id || loading}
              >
                <option value="">
                  {!form.ysb_school_id
                    ? "Pilih Sekolah terlebih dahulu"
                    : "Pilih Tingkatan"}
                </option>
                {grades.map((grade) => (
                  <option key={grade.id} value={grade.id}>
                    {grade.name_level || grade.name || grade.grade_name || grade.nama_tingkatan}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* <div className="sims-import-template-card">
            <div className="sims-import-template-icon">
              <FontAwesomeIcon icon={faFileExcel} />
            </div>
            <div className="sims-import-template-copy">
              <div className="sims-import-template-title">Template Excel Siswa</div>
              <div className="sims-import-template-desc">
                Unduh template dengan struktur kolom yang sesuai untuk mengisi data siswa.
              </div>
            </div>
            <button
              type="button"
              className="sims-import-download"
              onClick={downloadStudentTemplate}
              disabled={loading}
            >
              <FontAwesomeIcon icon={faDownload} />
              Download
            </button>
          </div> */}

          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="import-file">
              Pilih Berkas Excel
            </label>
            <label className="sims-import-upload-zone" htmlFor="import-file">
              <FontAwesomeIcon icon={faUpload} className="sims-import-upload-icon" />
              <strong>Klik untuk upload file Excel</strong>
              <span>atau drag &amp; drop file di sini</span>
              <small>Format .xlsx atau .xls</small>
            </label>
            <input
              id="import-file"
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              className="sims-import-file-input"
              disabled={loading}
              required
            />
          </div>

          {fileName && (
            <div className="sims-import-file-preview">
              <FontAwesomeIcon icon={faFileExcel} className="sims-import-file-icon" />
              <div className="sims-import-file-copy">
                <strong>{fileName}</strong>
                <span>
                  <FontAwesomeIcon icon={faCheckCircle} /> Terbaca: {excelData.length} baris data siswa
                </span>
              </div>
              <button
                type="button"
                className="sims-import-file-remove"
                onClick={() => {
                  setFileName("");
                  setExcelData([]);
                  const input = document.getElementById("import-file");
                  if (input) input.value = "";
                }}
                disabled={loading}
                aria-label="Hapus berkas"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={loading}
          >
            Batal
          </button>
          <button
            type="submit"
            className="sims-modal-submit"
            disabled={loading || excelData.length === 0}
          >
            {loading ? <span className="sims-button-spinner" /> : <FontAwesomeIcon icon={faUpload} />}
            <span>{loading ? "Mengimpor..." : "Import"}</span>
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
